const e = {
  undo: "Visszavonás",
  redo: "Újra",
  confirm: "megerősít",
  clear: "Egyértelmű",
  more: "több",
  cancel: "Megszünteti",
  update: "Frissítés"
}, t = {
  positiveText: "megerősít",
  negativeText: "Megszünteti"
}, a = {
  placeholder: "Kérlek, válassz",
  loading: "Betöltés"
}, l = {
  clear: "Egyértelmű",
  now: "Most",
  confirm: "megerősít",
  selectTime: "Válassza az Idő lehetőséget",
  selectDate: "Válassza a Dátum lehetőséget",
  datePlaceholder: "Válassza a Dátum lehetőséget",
  datetimePlaceholder: "Válassza a Dátum és idő lehetőséget",
  monthPlaceholder: "Válassz hónapot",
  yearPlaceholder: "Válassza az Évet",
  quarterPlaceholder: "Válassza a Negyed lehetőséget",
  startDatePlaceholder: "Kezdő dátum",
  endDatePlaceholder: "Befejezés dátuma",
  startDatetimePlaceholder: "Kezdés dátuma és időpontja",
  endDatetimePlaceholder: "Befejezés dátuma és időpontja",
  startMonthPlaceholder: "Kezdő hónap",
  endMonthPlaceholder: "Hónap vége",
  today: "Ma"
}, s = {
  checkTableAll: "Válassza ki az összeset a táblázatból",
  uncheckTableAll: "Törölje az összes kijelölést a táblázatban",
  confirm: "Megerősít",
  clear: "Egyértelmű",
  apply: "Alkalmaz",
  filters: "Szűrők",
  sort: "Fajta"
}, r = {
  sourceTitle: "Forrás",
  targetTitle: "Cél"
}, n = {
  selectAll: "Mindet kiválaszt",
  unselectAll: "Minden kijelölés megszüntetése",
  clearAll: "Egyértelmű"
}, o = {
  description: "Nincs adat"
}, i = {
  placeholder: "Kérlek, válassz"
}, c = {
  placeholder: "Válassza az Idő lehetőséget",
  positiveText: "rendben",
  negativeText: "Megszünteti",
  now: "Most"
}, d = {
  goto: "Menj",
  selectionSuffix: "oldalon",
  next: "Következő",
  previous: "Előző"
}, z = {
  add: "Hozzáadás"
}, m = {
  loading: "Betöltés"
}, g = {
  placeholder: "Kérem írja be"
}, p = {
  placeholder: "Kérem írja be"
}, h = {
  create: "Teremt"
}, k = {
  title: "Témaszerkesztő",
  clearAllVars: "Minden változó törlése",
  clearSearch: "Keresés törlése",
  filterCompName: "Szűrőkomponens neve",
  filterVarName: "Szűrőváltozó neve",
  import: "Importálás",
  export: "Export",
  restore: "Visszaállítás alapértelmezettre"
}, u = {
  tipPrevious: "Előző kép (←)",
  tipNext: "Következő kép (→)",
  tipCounterclockwise: "Óramutató járásával ellentétes irányban",
  tipClockwise: "Óramutató járásával megegyező",
  tipZoomOut: "Kicsinyítés",
  tipZoomIn: "Nagyítás",
  tipClose: "Bezárás (Esc)",
  tipOriginalSize: "Nagyítás az eredeti méretre"
}, y = {
  heading: "Rendezés és szűrők",
  sortHeading: "Rendezés",
  newestFirst: "Legújabb első",
  oldestFirst: "A legrégebbi első",
  ascending: "Asc",
  descending: "Desc",
  apply: "Alkalmaz",
  clear: "Egyértelmű",
  cancel: "Megszünteti",
  filters: "Szűrők"
}, P = {
  noMatchingFound: "Nem található egyező találat"
}, T = {
  margin: "Margó",
  padding: "Kitöltés",
  reset: "Visszaállítás",
  errorMsg: "A megadott érték érvénytelen."
}, b = {
  brandColors: "Márkaszínek",
  noBrandColors: "Még nem adtál hozzá márkaszíneket.",
  getStarted: "Kezdd el",
  add: "Hozzáad",
  default: "Alapértelmezett"
}, v = {
  addColor: "Új Szín Hozzáadása",
  editColor: "Szín Szerkesztése",
  add: "Hozzáad",
  noData: "Még nem adtál hozzá színeket.",
  invalidCode: "Érvénytelen színkód",
  defaultColor: "Alapértelmezett Színek"
}, f = {
  global: e,
  Popconfirm: t,
  Cascader: a,
  DatePicker: l,
  DataTable: s,
  LegacyTransfer: r,
  Transfer: n,
  Empty: o,
  Select: i,
  TimePicker: c,
  Pagination: d,
  DynamicTags: z,
  Log: m,
  Input: g,
  InputNumber: p,
  DynamicInput: h,
  ThemeEditor: k,
  Image: u,
  SortFilter: y,
  IconPicker: P,
  Spacing: T,
  BrandColorPicker: b,
  BrandBoard: v
};
export {
  v as BrandBoard,
  b as BrandColorPicker,
  a as Cascader,
  s as DataTable,
  l as DatePicker,
  h as DynamicInput,
  z as DynamicTags,
  o as Empty,
  P as IconPicker,
  u as Image,
  g as Input,
  p as InputNumber,
  r as LegacyTransfer,
  m as Log,
  d as Pagination,
  t as Popconfirm,
  i as Select,
  y as SortFilter,
  T as Spacing,
  k as ThemeEditor,
  c as TimePicker,
  n as Transfer,
  f as default,
  e as global
};
